<div class="scroll-to-top" [ngClass]="{'show-scrollTop': windowScrolled}">
  <button type="button" class="btn active customButton" data-toggle="button" aria-pressed="true" (click)="scrollToTop()">
    <i class="fas fa-chevron-up"></i>
  </button>
</div>
